/**
 * Класс AbstractOperation определяет базовые методы для целей наследования в кастомных классах геометрических операций
 */
class AbstractOperation {
  constructor(params) {
    this.params = params;
  }

  operation(params) {
    return this;
  }

  execute(params){
    return this;
  }
}

module.exports = AbstractOperation;